import { onMounted } from 'vue'
import initialize from './init'

export function useCanny() {
    onMounted(() => {
        initialize(window, document)
    })
}
